/**
 * @description: 判断是否是外部链接
 * @param {string}
 * @return {Boolean}
 * @author: syx
 */
export function isExternal(path) {
  return /^(https?:|mailto:|tel:)/.test(path)
}

/**
 * @description: 判断链接地址是否填写正确
 * @param {string} url
 * @return {Boolean}
 * @author: syx
 */
export function validURL(url) {
  const reg = /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/
  return reg.test(url)
}

/**
 * @description: 判断是否是小写字母
 * @param {string} str
 * @return {Boolean}
 * @author: syx
 */
export function validLowerCase(str) {
  const reg = /^[a-z]+$/
  return reg.test(str)
}

/**
 * @description: 判断是否是大写字母
 * @param {string} str
 * @return {Boolean}
 * @author: syx
 */
export function validUpperCase(str) {
  const reg = /^[A-Z]+$/
  return reg.test(str)
}

/**
 * @description: 判断是否是字母
 * @param {string} str
 * @return {Boolean}
 * @author: syx
 */
export function validAlphabets(str) {
  const reg = /^[A-Za-z]+$/
  return reg.test(str)
}

/**
 * @description: 判断是否是字符串类型
 * @param {string} str
 * @return {Boolean}
 * @author: syx
 */
export function isString(str) {
  if (typeof str === "string" || str instanceof String) {
    return true
  }
  return false
}

/**
 * @description: 判断是否是数组类型
 * @param {Array} arg
 * @return {Boolean}
 * @author: syx
 */
export function isArray(arg) {
  if (typeof Array.isArray === "undefined") {
    return Object.prototype.toString.call(arg) === "[object Array]"
  }
  return Array.isArray(arg)
}